query GetStagesets {
    stagesets(includeEmpty: false, includeOnlyActiveStatus: true) {
        id
        type
        canAccess
        default
        name
        stages {
            id
            name
        }
        isArchived
    }
}
